export default [
    {
        path: '/publication/success',
        name: 'publication-success',
        component: () => import('@/pages/Publication/PublicationSuccess.vue'),
    },

]